// extracted by mini-css-extract-plugin
export default {"statusBox":"myOrdersStatus_statusBox__xDvQu","statusBadge":"myOrdersStatus_statusBadge__ld8Qt"};